import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import { ItemId, Order } from '../../../types/items';
import { CancelOrderForm, OrderPayload, VideoOrderForm } from './types';

export const getOrderListRequest = action(
  'GET_ORDER_LIST_REQUEST',
  withPayload<ListParams>(),
);

export const getOrderListSuccess = action(
  'GET_ORDER_LIST_SUCCESS',
  withPayload<ItemList<Order>>(),
);

export const getOrderListFail = action(
  'GET_ORDER_LIST_FAIL',
  withoutPayload,
);

export const setOrderListDirty = action(
  'SET_ORDER_LIST_DIRTY',
  withPayload<boolean>(),
);

export const clearOrderList = action(
  'CLEAR_ORDER_LIST',
  withoutPayload,
);

export const initOrderRequest = action(
  'INIT_ORDER_REQUEST',
  withoutPayload,
);

export const initOrderSuccess = action(
  'INIT_ORDER_SUCCESS',
  withPayload<Order>(),
);

export const initOrderFail = action(
  'INIT_ORDER_FAIL',
  withoutPayload,
);

export const resetCurrentOrder = action(
  'RESET_CURRENT_ORDER',
  withoutPayload,
);

export const createOrderRequest = action(
  'CREATE_ORDER_REQUEST',
  withPayload<OrderPayload>(),
);
export const createOrderSuccess = action(
  'CREATE_ORDER_SUCCESS',
  withPayload<Order>(),
);
export const createOrderFail = action(
  'CREATE_ORDER_FAIL',
  withoutPayload,
);

export const createVideoEditOrderRequest = action(
  'CREATE_VIDEO_EDIT_ORDER_REQUEST',
  withPayload<VideoOrderForm>(),
);

export const saveVideoEditOrderRequest = action(
  'SAVE_VIDEO_EDIT_ORDER_REQUEST',
  withPayload<VideoOrderForm>(),
);

export const saveOrderRequest = action(
  'SAVE_ORDER_REQUEST',
  withPayload<Order>(),
);
export const saveOrderSuccess = action(
  'SAVE_ORDER_SUCCESS',
  withPayload<Order>(),
);
export const saveOrderFail = action(
  'SAVE_ORDER_FAIL',
  withoutPayload,
);

export const getOrderRequest = action(
  'GET_ORDER_REQUEST',
  withPayload<ItemId>(),
);

export const getOrderSuccess = action(
  'GET_ORDER_SUCCESS',
  withPayload<Order>(),
);

export const getOrderFail = action(
  'GET_ORDER_FAIL',
  withoutPayload,
);

export const cancelOrderRequest = action(
  'CANCEL_ORDER_REQUEST',
  withPayload<CancelOrderForm>(),
);

export const cancelOrderSuccess = action(
  'CANCEL_ORDER_SUCCESS',
  withoutPayload,
);

export const cancelOrderFail = action(
  'CANCEL_ORDER_FAIL',
  withoutPayload,
);
